<template>
  <el-input ref="input" :value="rawValue" :disabled="disabled" :readonly="readonly" :size="size" @input="input" @change="change" />
</template>

<script>
function ParseVal(val, scale, min, max) {
  if (val === '' || val === '-' || val === '=') return val

  var reg = new RegExp(`-?\\d+(\\.\\d{0,${scale}})?`)
  var rtn = reg.exec(val)
  rtn = rtn === null ? '' : rtn[0]
  if (min != undefined && rtn != '') {
    if (parseFloat(rtn) < parseFloat(min)) {
      return min
    }
  }
  if (max != undefined && rtn != '') {
    if (parseFloat(rtn) > parseFloat(max)) {
      return max
    }
  }
  return rtn
}

function ChangeRawValue() {
  if (this.rawValue === '-') return
  if (parseFloat(this.rawValue) === parseFloat(this.value)) return
  this.rawValue = this.value === 0 || this.value > 0 || this.value < 0 ? `${this.value}` : ''
}

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: Number,
    disabled: Boolean,
    readonly: Boolean,
    size: String,
    scale: {
      type: Number,
      default: 2
    },
    min: {
      type: String,
      default: '0'
    },
    max: String
  },
  data: function() {
    return {
      rawValue: null
    }
  },
  watch: {
    value: function() {
      ChangeRawValue.call(this)
    }
  },

  mounted: function() {
    ChangeRawValue.call(this)
  },

  methods: {
    input: function(val) {
      this.rawValue = ParseVal(val, this.scale, this.min, this.max)
      this.$emit('input', this.rawValue === '' || this.rawValue === '-' ? null : parseFloat(this.rawValue))
      this.$emit('keyup', val)
    },
    change: function(val) {
      this.rawValue = ParseVal(val, this.scale, this.min, this.max)
      this.$emit('change', this.rawValue === '' || this.rawValue === '-' ? null : parseFloat(this.rawValue))
    },
    focus: function() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style>

</style>
